import PageContainer from "../PageContainer";
import { useData } from "../../../contexts/DataContext/DataContextt";
import { saveClass } from "../../../services/classService";
import { useState } from "react";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";
import { ClassForm } from "./ClassForm";

const AddClass = () => {
  const { loading, language, setClasses } = useData();
  const { showNotification } = usePreload();
  const [saving, setSaving] = useState(false);

  const onSave = async (updatedRow) => {
    if (!updatedRow.classCode)
      return showNotification("class code is required", "error");

    try {
      setSaving(true);
      let newClass = { ...updatedRow };
      await saveClass(newClass);
      showNotification(`new class was added!`, "success");
    } catch (e) {
      console.error(e);
      showNotification(
        `something went wrong when adding ${updatedRow?.classCode} class.`,
        "error",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Class"
      breadcrumbs={[
        { title: "ETIM Class", path: "/classNew" },
        { title: "New" },
      ]}
    >
      <ClassForm
        onSave={onSave}
        props={{
          row: {},
          loading: loading,
          uploading: saving,
          showCancel: false,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddClass;
